/**
 * Background class for an event tag chip.
 *
 * Tailwind only generates classes it can find as complete strings in the source, so
 * `bg-${color}-500` works only while that exact class happens to appear somewhere else.
 * The colours used by the calendars are listed here in full.
 */
const TAG_BACKGROUNDS: Record<string, string> = {
  blue: "bg-blue-500",
  green: "bg-green-500",
  gray: "bg-gray-500",
  red: "bg-red-500",
  orange: "bg-orange-500",
  yellow: "bg-yellow-500",
  purple: "bg-purple-500",
  teal: "bg-teal-500",
  pink: "bg-pink-500",
  indigo: "bg-indigo-500",
};

export const tagBackgroundClass = (color?: string): string =>
  TAG_BACKGROUNDS[color ?? ""] ?? `bg-${color}-500`;
